import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { constantUrl } from "../../Shared/constantUrl";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { LosService } from "../services/los.service";
declare var $: any;

@Component({
  selector: "app-internal-query-logs-list",
  templateUrl: "./internal-query-logs-list.component.html",
  styleUrl: "./internal-query-logs-list.component.scss",
  standalone: false,
})
export class InternalQueryLogsListComponent implements OnInit {
  currentUser: any;
  showSpinner: boolean = false;
  selectedTabIndex: number = 0;
  FromDate: any = "";
  ToDate: any = "";
  Status: string = "All";
  Priority: string = "All";

  AllQueryLogsList: any[] = [];
  QueryLogsList: any[] = [];
  allDocsList: any[] = [];
  selectedQueryRow: any = null;
  selectedQueryDocs: any[] = [];

  dataSource: any;
  displayedColumns: string[] = [
    "Index",
    "Application_No",
    "From_EmpName",
    "To_EmpName",
    "From_Remark",
    "To_Remark",
    "Priority",
    "Status",
    "Send_On",
    "Reply_On",
    "Docs",
  ];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private dataSharingService: DataSharingService,
    private losService: LosService,
    private snackBar: MatSnackBar,
    private encdec: EncrDecrService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle?.next("Internal Query Logs List");
    this.dataSharingService.LOSHeaderTitle?.next("Internal Query Logs List");
    this.currentUser = JSON.parse(
      sessionStorage.getItem("currentUser") || "{}",
    );

    this.Get_Internal_Query_Logs_List();
  }

  formatDate(date: any): string {
    if (!date) return "";
    if (typeof date === "string") return date;
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  Get_Internal_Query_Logs_List(): void {
    this.showSpinner = true;
    const reqData = {
      LoginUserId: this.currentUser?.userId || 0,
      LoanId: 0,
      Status: this.Status,
      Priority: this.Priority,
      FromDate: this.formatDate(this.FromDate),
      ToDate: this.formatDate(this.ToDate),
      Type: "All",
    };

    this.losService.Get_Internal_Query_Logs_List(reqData).subscribe({
      next: (res: any) => {
        this.showSpinner = false;
        const rawList = Array.isArray(res)
          ? res
          : res?.Item1 || res?.item1 || res?.data || [];
        this.allDocsList = Array.isArray(res)
          ? []
          : res?.Item2 || res?.item2 || [];

        this.AllQueryLogsList = rawList;
        this.filterLogsByTab();
      },
      error: (err: any) => {
        this.showSpinner = false;
        console.error("Error fetching internal query logs list:", err);
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Failed to fetch Internal Query Logs list",
          ...this.configSuccess,
        });
      },
    });
  }

  filterLogsByTab(): void {
    const currentUserId = this.currentUser?.userId;
    if (this.selectedTabIndex === 0) {
      this.QueryLogsList = this.AllQueryLogsList.filter(
        (x: any) =>
          String(x.From_EmpId || x.From_Emp) === String(currentUserId),
      );
    } else {
      this.QueryLogsList = this.AllQueryLogsList.filter(
        (x: any) =>
          String(x.From_EmpId || x.From_Emp) !== String(currentUserId),
      );
    }

    this.dataSource = new MatTableDataSource(this.QueryLogsList);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  onTabChange(event: any): void {
    this.selectedTabIndex = event.index;
    if (this.AllQueryLogsList && this.AllQueryLogsList.length > 0) {
      this.filterLogsByTab();
    } else {
      this.Get_Internal_Query_Logs_List();
    }
  }

  onFilterChange(): void {
    this.Get_Internal_Query_Logs_List();
  }

  DateChange(): void {
    this.onFilterChange();
  }

  resetFilters(): void {
    this.FromDate = "";
    this.ToDate = "";
    this.Status = "All";
    this.Priority = "All";
    this.Get_Internal_Query_Logs_List();
  }

  applyFilter(filterValue: string): void {
    if (this.dataSource) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  isRepliedByToEmp(row: any): boolean {
    if (!row) return false;
    const isReplied =
      row.Status === "Replied" || row.Status === "R" || row.Status === "Completed";
    const toEmpId = row.To_EmpId || row.To_Emp;
    const isToEmp =
      toEmpId != null &&
      String(toEmpId) === String(this.currentUser?.userId);
    return isReplied && isToEmp;
  }

  goToDetail(row: any): void {
    if (this.isRepliedByToEmp(row)) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "You have already replied to this query.",
        ...this.configSuccess,
      });
      return;
    }

    console.log("row", row);
    let Processid = this.encdec.encrypt(
      encodeURIComponent(row.Processid || row.ProcessId || row.Process_Id || 0),
    );
    let ProductId = this.encdec.encrypt(
      encodeURIComponent(row.productId || row.ProductId || row.Product_Id || 0),
    );
    let Loan_Id = this.encdec.encrypt(
      encodeURIComponent(row.Loan_Id || row.LoanId || row.Loan_id || 0),
    );
    var Status = "C";
    var RevertedProcessId = this.encdec.encrypt(encodeURIComponent(0));
    var RevertedProcessName = this.encdec.encrypt(encodeURIComponent(""));
    var RevertedEmployeeName = this.encdec.encrypt(encodeURIComponent(""));
    var IsEdit = this.encdec.encrypt(encodeURIComponent(0));
    var RevertedCount = this.encdec.encrypt(encodeURIComponent(""));

    this.router.navigate(
      [
        `quickloan-dashboard/quick-loan-view/details/${Processid}/${ProductId}/${Loan_Id}/${Status}/${RevertedProcessId}/${RevertedProcessName}/${RevertedEmployeeName}/${IsEdit}/${RevertedCount}`,
      ],
      {
        queryParams: {
          QueryId: row.Id,
          QueryStatus: row.Status,
          From_EmpId: row.From_EmpId || row.From_Emp,
          From_EmpName: row.From_EmpName || "",
          Priority: row.Priority,
        },
      },
    );
  }

  getDocsForQuery(queryId: number): any[] {
    if (!queryId || !this.allDocsList || this.allDocsList.length === 0)
      return [];
    return this.allDocsList.filter(
      (d: any) =>
        String(d.Query_Id || d.query_Id || d.QueryId) === String(queryId),
    );
  }

  hasDocs(queryId: number): boolean {
    return this.getDocsForQuery(queryId).length > 0;
  }

  openQueryDocsModal(row: any): void {
    this.selectedQueryRow = row;
    this.selectedQueryDocs = this.getDocsForQuery(row.Id);
    $("#queryDocsModal").modal("show");
  }

  closeQueryDocsModal(): void {
    $("#queryDocsModal").modal("hide");
    this.selectedQueryRow = null;
    this.selectedQueryDocs = [];
  }

  viewDocument(doc: any): void {
    if (!doc || !doc.Doc_Path) return;
    let url = doc.Doc_Path;
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      const cleanPath = url.startsWith("/") ? url.substring(1) : url;
      const appNo = doc.Application_No || doc.ApplicationNo || this.selectedQueryRow?.Application_No || "";

      if (cleanPath.includes("ApplicationDocument/")) {
        const relativePath = cleanPath.startsWith("wwwroot/")
          ? cleanPath
          : `wwwroot/${cleanPath.replace(/^uploadDoc\//, "")}`;
        url = `${constantUrl.apiEndpointUploadDoc}/${relativePath}`;
      } else {
        const folder = (appNo && !cleanPath.startsWith(`${appNo}/`)) ? `${appNo}/` : "";
        url = `${constantUrl.apiEndpointUploadDoc}/wwwroot/Document/ApplicationDocument/${folder}${cleanPath}`;
      }
    }
    window.open(url, "_blank");
  }
}
